import { render, staticRenderFns } from "./SliderButton.vue?vue&type=template&id=5f840e44&scoped=true&"
import script from "./SliderButton.vue?vue&type=script&lang=js&"
export * from "./SliderButton.vue?vue&type=script&lang=js&"
import style0 from "./SliderButton.vue?vue&type=style&index=0&id=5f840e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f840e44",
  null
  
)

export default component.exports